import React, {ReactElement, useMemo} from "react";
import {StudyMismatch} from "../dicom/Mismatch";
import {CDUploadDataOverridingMetadata, DicomizeDataMetadata} from "../types/Session";
import {useTranslation} from "react-i18next";

export default function RequestMetadataBox({requestMetadata, mismatches}: {
	requestMetadata: CDUploadDataOverridingMetadata | DicomizeDataMetadata | null;
	mismatches: Map<string, StudyMismatch> | null;
}): ReactElement {
	const {t} = useTranslation();

	const entries = useMemo(() => {
		return requestMetadata
				? Object.entries(requestMetadata)
						.filter(([, value]) => value != null)
						.sort()
				: []
	}, [requestMetadata]);

	return (
			<div className="data-container">
				<div className="upload-data-title">{t("requestDataPanel_title")}</div>
				<div className="upload-data-subtitle">
					{t("requestDataPanel_subtitle", {count: entries.length})}
				</div>

				{entries.length > 0 && (
						<div className="upload-data-box">
							{entries.map(([key, value]) => {
								const hasMismatch =
										mismatches != null &&
										Array.from(mismatches.values()).some((mismatch) => mismatch[key as keyof StudyMismatch]);

								return (
										<React.Fragment key={key}>
											<div><strong>{key}:</strong></div>
											<div className={hasMismatch ? "mismatch" : ""}>{String(value)}</div>
										</React.Fragment>
								);
							})}
						</div>
				)}
			</div>
	);
}
